import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["preview", "player", "video"]

  connect() {
    this.activated = false
  }

  activate() {
    if (this.activated) return
    this.activated = true

    this.previewTarget.classList.add("hidden")
    this.playerTarget.classList.remove("hidden")
    this.videoTarget.play().catch(() => {})
  }

  minimize() {
    this.videoTarget.pause()
    this.videoTarget.currentTime = 0

    this.playerTarget.classList.add("hidden")
    this.previewTarget.classList.remove("hidden")

    this.activated = false
  }
}
